import React from 'react'
import MessageForm from './MessageForm'
import MyMessage from './MyMessage'
import TheirMessage from './TheirMessage'
import {UsergroupAddOutlined} from '@ant-design/icons'

const ChatFeed =(props)=>{
    const{chats,activeChat,userName,messages}=props;

    //find activechats
    const chat=chats && chats[activeChat];

    //print their message
    const renderReadReceipts = (message, isMyMessage) => {
        return chat.people.map((person, index) => person.last_read === message.id && (
        <div
          key={`read_${index}`}
          className="read-receipt"
          style={{
            float: isMyMessage ? 'right' : 'left',
            backgroundImage: `url(${person.person.avatar})`,
          }}
        />
    ))}

    //generate messages
    const renderMessages =()=>{
        const keys=Object.keys(messages);//keys of messages
        //console.log(keys);

        return keys.map((key,index)=>{
            const message=messages[key];
            const lastMessageKey =index=== 0? null :keys[index-1];
            const isMyMessage= userName===message.sender.username;

            //console.log(lastMessageKey);

            return(
                <div key={`msg_${index}`} style={{width:'100%'}}>
                    <div className="message-block">
                        {
                            isMyMessage?
                            <MyMessage message={message}/>:
                            <TheirMessage message={message} lastMessage={messages[lastMessageKey]}/>
                        }
                    </div>
                    <div className="read-receipts" style={{marginRight:isMyMessage? '18px':'0px',marginLeft:isMyMessage?'0px':'68px'}}>
                        {renderReadReceipts(message, isMyMessage)}
                    </div>
                </div>
            )
        })
    }
    

    // if there is no chat
    if(!chat) return <div/>

    return(
        
        <div className="chat-feed">
            <div className="chat-title-container">
                <div className="chat-title">{chat?.title}</div>
                <div className="chat-subtitle">
                    <UsergroupAddOutlined />
                    {
                        ' Group Members: '+chat.people.map((person)=> `${person.person.username}`)
                    }

                </div>
                {/* //messages */}
                {renderMessages()}

                <div style={{height:'100px'}}/>
                <div className="message-form-container">
                    <MessageForm {...props} chatId={activeChat}/>

                </div>
            </div>
        </div>
    )
}
export default ChatFeed